<template>
  <v-dialog
      v-model="show"
      max-width="600px"
    >
      <v-form ref="form" lazy-validation :disabled="loading" @submit="deleteProject" onsubmit="return false;">
        <v-card>
          <v-card-title>
            {{ $t('project.delete') }}
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="show = false"
            >
            <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <p>{{ $t('project.typeProjectName') }} <b class="error--text">{{ project.name }}</b> {{ $t('project.toConfirmDeletion') }}</p>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    :label="$t('project.projectName')"
                    required
                    v-model="projectName"
                    autofocus
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              class="raison-btn"
              :disabled="loading || deletionConfirmed"
              :loading="loading"
            >
              <v-icon left>mdi-delete</v-icon>
              {{ $t('global.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
</template>
<script>
import projectService from '@/services/projects.js'

export default {
  name: 'ConfirmProjectDeletionDialog',

  data () {
    return {
      projectName: "",
      loading: false,
    }
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },

  computed: {
    deletionConfirmed() {
      return this.projectName !== this.project.name
    },
    show: {
      get () {
          return this.open;
      },
      set (value) {
        if(!value) {
          this.onCancel()
        }
        this.$emit('update:open', value);
      }
    }
  },

  methods: {
    onCancel() {
      this.projectName = ""
    },
    deleteProject(event) {
      event.preventDefault()
      this.loading = true
      projectService.deleteProject(this.project.id)
        .then(() => {
          this.projectName = ""
          this.$emit('update:open', false)
          this.$emit('project-deleted', { projectId: this.project.id })
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.loading = false
        });
    },
  },
}
</script>
<style scoped>
</style>
